import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { CircularProgress } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import AppAdminTable from "components/AppAdminTable/AppAdminTable";
import { toDate } from "helpers/dateHelper";
import tourPackageCategoryAdminService from "services/admin/tourpackageCategoryService";

const TourPackageCategoriesList = () => {
    const columnConfig = [
        {
            label: '#',
            render: (i, index) => index + 1
        },
        {
            key: 'name',
            label: 'Название категории',

        },
        {
            key: 'createdAt',
            label: 'Дата создания',
            formatter: (v) => toDate(v)
        }
    ]
    const [data, loadData, loading, error] = useRemoteResource(tourPackageCategoryAdminService.getAll, "");


    const onDelete = async (item) => {
        await tourPackageCategoryAdminService.delete(item.id);
        loadData();
    };

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.data.length === 0) {
            return <div>Категории отсутсвует. Чтобы добавить категорию пожалуйста, нажмите на кнопку "Добавить" сверху</div>
        }
        if (data.data.length > 0) {
            return <AppAdminTable data={data.data} columnConfig={columnConfig} onDelete={onDelete}></AppAdminTable>
        }
    }
    return (
        <ListPage pageTitle="Список вопросов">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(TourPackageCategoriesList);
